module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', [_c('form', {
    staticClass: "form-horizontal form-label-left"
  }, [_c('v-flex', {
    attrs: {
      "md8": "",
      "lg6": "",
      "offset-lg3": "",
      "offset-md2": "",
      "mt-2": ""
    }
  }, [_c('v-subheader', [_vm._v(_vm._s(_vm.$t('profile.profile')))]), _vm._v(" "), _c('v-card', [_c('v-list', {
    attrs: {
      "two-line": ""
    }
  }, [_c('v-list-tile', [_c('v-list-tile-content', [_c('v-list-tile-sub-title', [_vm._v(_vm._s(_vm.$t('profile.role')) + ":")]), _vm._v(" "), _c('v-list-tile-title', {
    staticClass: "profile-title"
  }, [_vm._v(_vm._s(_vm.edit.roleName))])], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "md8": "",
      "lg6": "",
      "offset-lg3": "",
      "offset-md2": "",
      "mt-2": ""
    }
  }, [_c('v-card', [_c('v-list', {
    attrs: {
      "two-line": ""
    }
  }, [_c('v-list-tile', [_c('v-list-tile-content', [_c('v-list-tile-sub-title', [_vm._v(_vm._s(_vm.$t('profile.organization')) + ":")]), _vm._v(" "), _c('v-list-tile-title', {
    staticClass: "profile-title"
  }, [_vm._v(_vm._s(_vm.edit.organizationName))])], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "md8": "",
      "lg6": "",
      "offset-lg3": "",
      "offset-md2": "",
      "mt-2": ""
    }
  }, [_c('v-card', [_c('v-list', {
    attrs: {
      "two-line": ""
    }
  }, [_c('v-list-tile', [_c('v-list-tile-content', [_c('v-list-tile-sub-title', [_vm._v(_vm._s(_vm.$t('profile.email')) + ":"), (!_vm.emailVerified) ? _c('span', {
    staticClass: "label label-warning",
    staticStyle: {
      "margin-left": "10px",
      "color": "orange"
    }
  }, [_vm._v(_vm._s(_vm.$t('profile.not-verified')))]) : _vm._e()]), _vm._v(" "), _c('v-list-tile-title', {
    staticClass: "profile-title"
  }, [_vm._v(_vm._s(_vm.edit.email))])], 1)], 1)], 1), _vm._v(" "), _c('v-list', [_c('v-list-tile', [_c('v-flex', {
    staticClass: "text-xs-center text-md-center text-lg-center"
  }, [((!_vm.emailVerified)) ? _c('v-btn', {
    staticClass: "btn warning",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.openVerifyForm
    }
  }, [_vm._v(_vm._s(_vm.$t('profile.verify')))]) : _vm._e(), _vm._v(" "), _c('v-btn', {
    staticClass: "btn primary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.openMailForm
    }
  }, [_vm._v(_vm._s(_vm.$t('profile.change-email')))])], 1)], 1)], 1), _vm._v(" "), _c('v-list', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: ((_vm.state == 'change_email')),
      expression: "(state == 'change_email')"
    }],
    attrs: {
      "two-line": ""
    }
  }, [_c('v-list-tile', [_c('v-list-tile-content', [_c('v-flex', {
    staticStyle: {
      "width": "100%"
    }
  }, [_c('v-text-field', {
    class: {
      'is-error-field': _vm.errors.newEmail()
    },
    attrs: {
      "type": "email",
      "two-line": "",
      "required": "",
      "label": _vm.$t('profile.new-email'),
      "rules": _vm.emailRules
    },
    model: {
      value: (_vm.newEmail),
      callback: function($$v) {
        _vm.newEmail = $$v
      },
      expression: "newEmail"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('v-list-tile', {
    staticClass: "text-xs-center text-md-center text-lg-center"
  }, [_c('v-flex', {
    staticClass: "text-xs-center"
  }, [_c('v-btn', {
    staticClass: "btn default",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.cancelEmail
    }
  }, [_vm._v(_vm._s(_vm.$t('profile.cancel')))]), _vm._v(" "), _c('v-btn', {
    staticClass: "btn primary",
    attrs: {
      "type": "button",
      "disabled": _vm.hasError
    },
    on: {
      "click": _vm.changeEmail
    }
  }, [_vm._v(_vm._s(_vm.$t('profile.continue')))])], 1)], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-form', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: ((_vm.state == 'change_password')),
      expression: "(state == 'change_password')"
    }],
    ref: "form",
    staticClass: "form-horizontal form-label-left",
    attrs: {
      "autocomplete": "off"
    }
  }, [_c('v-flex', {
    attrs: {
      "md8": "",
      "lg6": "",
      "offset-lg3": "",
      "offset-md2": "",
      "mt-4": ""
    }
  }, [_c('v-subheader', [_vm._v(_vm._s(this.$t('profile.change-password-title')))]), _vm._v(" "), _c('v-card', [(_vm.passerror) ? _c('v-alert', {
    attrs: {
      "type": "error",
      "dismissible": ""
    },
    model: {
      value: (_vm.passerror),
      callback: function($$v) {
        _vm.passerror = $$v
      },
      expression: "passerror"
    }
  }, [_vm._v(_vm._s(_vm.passerror))]) : _vm._e(), _vm._v(" "), _c('v-list', {
    attrs: {
      "two-line": ""
    }
  }, [_c('v-list-tile', [_c('v-list-tile-content', [_c('v-text-field', {
    attrs: {
      "type": "password",
      "two-line": "",
      "required": "",
      "label": _vm.$t('profile.old-password'),
      "rules": _vm.oldpassRules,
      "autocomplete": "new-password"
    },
    model: {
      value: (_vm.password.old),
      callback: function($$v) {
        _vm.$set(_vm.password, "old", $$v)
      },
      expression: "password.old"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('v-list', {
    attrs: {
      "two-line": ""
    }
  }, [_c('v-list-tile', [_c('v-list-tile-content', [_c('v-text-field', {
    attrs: {
      "type": "password",
      "id": "passwordNew",
      "two-line": "",
      "required": "",
      "label": _vm.$t('profile.new-password'),
      "rules": _vm.newpassRules,
      "autocomplete": "new-password"
    },
    model: {
      value: (_vm.password.new),
      callback: function($$v) {
        _vm.$set(_vm.password, "new", $$v)
      },
      expression: "password.new"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('v-list', {
    attrs: {
      "two-line": ""
    }
  }, [_c('v-list-tile', [_c('v-list-tile-content', [_c('v-text-field', {
    attrs: {
      "type": "password",
      "id": "passwordConfirm",
      "two-line": "",
      "required": "",
      "label": _vm.$t('profile.confirm-new-password'),
      "rules": _vm.newconfirmpassRules,
      "autocomplete": "new-password"
    },
    model: {
      value: (_vm.password.confirm),
      callback: function($$v) {
        _vm.$set(_vm.password, "confirm", $$v)
      },
      expression: "password.confirm"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('v-list', {
    attrs: {
      "two-line": ""
    }
  }, [_c('v-list-tile', {
    staticClass: "text-xs-center text-md-center text-lg-center"
  }, [_c('v-flex', [_c('v-btn', {
    staticClass: "btn default",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.cancelPassword
    }
  }, [_vm._v(_vm._s(_vm.$t('profile.cancel')))]), _vm._v(" "), _c('v-btn', {
    staticClass: "btn primary",
    attrs: {
      "type": "button",
      "disabled": _vm.hasError
    },
    on: {
      "click": _vm.updatePassword
    }
  }, [_vm._v(_vm._s(_vm.$t('profile.submit')))])], 1)], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "md8": "",
      "lg6": "",
      "offset-lg3": "",
      "offset-md2": "",
      "mt-4": ""
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: ((_vm.state == '')),
      expression: "(state == '')"
    }],
    staticClass: "form-group"
  }, [_c('v-flex', {
    staticClass: "text-xs-center text-md-center text-lg-center"
  }, [_c('v-btn', {
    staticClass: "btn warning",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.openPasswordForm
    }
  }, [_vm._v(_vm._s(_vm.$t('profile.change-password')))])], 1)], 1)]), _vm._v(" "), ((!_vm.emailVerified)) ? _c('v-flex', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: ((_vm.state == 'confirm')),
      expression: "(state == 'confirm')"
    }],
    attrs: {
      "md8": "",
      "lg6": "",
      "offset-lg3": "",
      "offset-md2": "",
      "mt-4": ""
    }
  }, [_c('v-subheader', [_vm._v(_vm._s(_vm.$t('profile.code-confirm-title')))]), _vm._v(" "), _c('v-card', [_c('v-card-title', {
    attrs: {
      "primary-title": ""
    }
  }, [_vm._v("\n        " + _vm._s(_vm.$t('profile.code-confirm-text1')) + "\n        "), _c('br'), _vm._v("\n        " + _vm._s(_vm.$t('profile.code-confirm-text2')) + "\n      ")]), _vm._v(" "), (_vm.mailerror) ? _c('v-alert', {
    attrs: {
      "type": "error",
      "dismissible": ""
    },
    model: {
      value: (_vm.mailerror),
      callback: function($$v) {
        _vm.mailerror = $$v
      },
      expression: "mailerror"
    }
  }, [_vm._v(_vm._s(_vm.mailerror))]) : _vm._e(), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs10": "",
      "offset-xs1": ""
    }
  }, [_c('v-text-field', {
    class: {
      'is-error-field': _vm.errors.confirminationCode()
    },
    attrs: {
      "type": "email",
      "two-line": "",
      "required": "",
      "label": _vm.$t('profile.code-confirm-input'),
      "autocomplete": "new-password"
    },
    model: {
      value: (_vm.confirminationCode),
      callback: function($$v) {
        _vm.confirminationCode = $$v
      },
      expression: "confirminationCode"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "text-xs-center",
    attrs: {
      "pb-4": ""
    }
  }, [_c('v-btn', {
    staticClass: "btn default",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.cancelEmail
    }
  }, [_vm._v(_vm._s(_vm.$t('profile.cancel')))]), _vm._v(" "), _c('v-btn', {
    staticClass: "btn warning",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.resendConfirmationCode
    }
  }, [_vm._v(_vm._s(_vm.$t('profile.resend')))]), _vm._v(" "), _c('v-btn', {
    staticClass: "btn primary",
    attrs: {
      "type": "button",
      "loading": _vm.loading,
      "disabled": _vm.loading
    },
    on: {
      "click": _vm.confirmEmail
    },
    nativeOn: {
      "click": function($event) {
        _vm.loader = 'loading'
      }
    }
  }, [_vm._v("\n          " + _vm._s(_vm.$t('profile.confirm')) + "\n          "), _c('span', {
    staticClass: "custom-loader",
    attrs: {
      "slot": "loader"
    },
    slot: "loader"
  }, [_c('v-icon', {
    attrs: {
      "light": ""
    }
  }, [_vm._v("cached")])], 1)])], 1)], 1)], 1) : _vm._e(), _vm._v(" "), _c('v-snackbar', {
    attrs: {
      "absolute": "",
      "top": "",
      "right": "",
      "color": _vm.snackbarColor,
      "timeout": _vm.snackbarTimeout
    },
    model: {
      value: (_vm.showSnackbar),
      callback: function($$v) {
        _vm.showSnackbar = $$v
      },
      expression: "showSnackbar"
    }
  }, [_vm._v("\n        " + _vm._s(_vm.snackbarMessage) + "\n    ")])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ../src/~/vue-loader/lib/template-compiler?{"id":"data-v-1d65085c","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../src/~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Profile.vue
// module id = 1911
// module chunks = 0